<template>
	<div class="application--wrapper__outer  compact-padding">
		<div class="application--wrapper__inner ">
			<slot name="heading"></slot>

			<form @submit.prevent="handleSubmit" id="form">
				<p class="form--input">
					<label for="email">E-mail address *</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="email"
					name="email"
					v-model="email"
					class="input-text__form"
					type="text"
					placeholder="emailexample@email.com"
					v-on:input="$v.email.$touch()"
					v-bind:class="{
						error: $v.email.$error,
						valid: $v.email.$dirty && !$v.email.$invalid
					}"
				/>
				<span
					class="form-group__message"
					v-if="!$v.email.email && $v.email.$error"
					>Please, provide valid email address</span
				>
				<span
					class="form-group__message"
					v-if="!$v.email.required && $v.email.$error"
					>Field is required</span
				>
				<span
					class="form-group__message"
					v-if="!$v.email.minLength && $v.email.$error"
					>Email must have at least
					{{ $v.email.$params.minLength.min }} letters.</span
				>

				<p class="form--input">
					<label for="first_name">First name *</label>
				</p>
				<div class="divider-md"></div>
				<input
					id="first_name"
					name="first_name"
					v-model="first_name"
					class="input-text__form"
					type="text"
					placeholder="John Doe"
					v-bind:class="{
						error: $v.first_name.$error,
						valid: $v.first_name.$dirty && !$v.first_name.$invalid
					}"
					v-on:input="$v.first_name.$touch()"
				/>
				<span
					class="form-group__message"
					v-if="!$v.first_name.required && $v.first_name.$error"
					>Field is required</span
				>

				<p class="form--input">
					<label for="fields"
						>Your fields of interest * (you can choose
						multiple)</label
					>
				</p>

				<multiselect-square
					label="Fields of interest"
					class="multiple-select"
					:list="departments"
					:value="activeDepartments"
					@input="onActiveDepartmentsChange"
					v-bind:class="{
						error: $v.activeDepartments.$error,
						valid:
							$v.activeDepartments.$dirty &&
							!$v.activeDepartments.$invalid
					}"
				></multiselect-square>

				<span
					class="form-group__message"
					v-if="
						!$v.activeDepartments.required &&
							$v.activeDepartments.$error
					"
					>Field is required</span
				>

				<div class="badge" v-for="dep in activeDepartments">
					<div
						style="display: flex; justify-items: center; justify-content: center; gap: 10px;"
					>
						<p
							style="font-weight: bold; cursor: pointer;"
							@click="removeActiveDepartments(dep.id)"
						>
							X
						</p>
						<p>
							{{ dep.name }}
						</p>
					</div>
				</div>

				<p class="form--input">
					<label for="email"
						>Your preferred projects (optional)</label
					>
				</p>

				<multiselect-square
					label="Projects"
					class="multiple-select"
					:list="projects"
					:value="activeProjects"
					@input="onActiveProjectsChange"
				></multiselect-square>

				<div class="badge" v-for="dep in activeProjects">
					<div
						style="display: flex; justify-items: center; justify-content: center; gap: 10px;"
					>
						<p
							style="font-weight: bold; cursor: pointer;"
							@click="removeActiveProjects(dep.id)"
						>
							X
						</p>
						<p>
							{{ dep.name }}
						</p>
					</div>
				</div>
				<text-area
					style="margin-top: 60px;"
					v-model="gdpr_accepted"
					v-bind:class="{
						error: $v.gdpr_accepted.$error,
						valid:
							$v.gdpr_accepted.$dirty &&
							!$v.gdpr_accepted.$invalid
					}"
				></text-area>

				<span
					class="form-group__message"
					v-if="!$v.gdpr_accepted.required && $v.gdpr_accepted.$error"
					>Field is required</span
				>

				<div class="divider"></div>
				<div v-if="apiError" class="form-error-wraper">
					<p class="form-response-error">{{ apiError }}</p>
				</div>
				<div class="submit-wrapper">
					<div class=" button-wrapper" v-if="!isSent">
						<button
							type="submit"
							:class="`position-item--${position_color}`"
						>
							Submit
						</button>
					</div>
					<div v-else></div>
					<div class="captcha-wrapper">
						<vue-recaptcha
							v-if="recaptchaSettings"
							size="invisible"
							badge="inline"
							ref="recaptcha"
							@verify="onVerify"
							@expired="onExpired"
							:sitekey="recaptchaSettings.key"
						></vue-recaptcha>
					</div>
				</div>
				<!--<span class="text-red text-bold">SUBMIT BUTTON TEMPORARILY REMOVED FOR SAFETY PURPOSES AND WELL BEING OF OUR SERVERS :) </span>-->
				<div class="divider"></div>

				<accordion></accordion>
			</form>
		</div>
		<popup-notification ref="successNotification"></popup-notification>
	</div>
</template>

<script>
import BasicButton from "../BasicButton";
import { addErrorNotification } from "../../utils/notifications";
// import MultipleSelect from "../common/MultipleSelect";
import MultiselectSquare from "../common/MultiselectSquare";
import { getDepartments } from "../../services/departments";
import { getProjects } from "../../services/projects";
import MultipleSelect from "../common/MultipleSelect";

import {
	minLength,
	required,
	requiredUnless,
	maxLength,
	email
} from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import {
	postApplication,
	postOpenApplication
} from "../../services/submitApplication";
import Attachments from "./Attachments";
import SingleSelect from "./../common/SingleSelect";
import { mapActions, mapState } from "vuex";
import TextArea from "../common/GDPR";
import Accordion from "../common/Accordion";
import InputWithSelect from "../common/InputWithSelect";
import PopupNotification from "../common/SubscribeNotification";
import { getCaptcha } from "../../services/captcha";
import EventBus from "../../EventBus";
import { postSubscribe } from "../../services/subscribe";

const DEPARTMENTS_TYPE = "departments";
const PROJECT_TYPE = "projects";

export default {
	components: {
		Accordion,
		TextArea,
		Attachments,
		BasicButton,
		VueRecaptcha,
		SingleSelect,
		InputWithSelect,
		PopupNotification,
		MultiselectSquare,
		MultipleSelect
	},
	name: "SubscribeForm",
	props: {
		position_id: {
			default: 0
		},
		position_color: {
			default: 0
		},
		isOpenApplication: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			apiError: null,
			departmentId: null,
			email: null,
			first_name: null,
			captchaResponse: null,
			isLoading: false,
			recaptchaSettings: null,
			activeDepartments: [],
			activeProjects: [],
			list: null,
			gdpr_accepted: false,
			isSent: false
		};
	},
	validations() {
		let rules = {
			email: {
				required,
				minLength: minLength(1),
				email
			},
			first_name: {
				required,
				minLength: minLength(1)
			},
			activeDepartments: {
				required
			},
			gdpr_accepted: {
				required
			}
		};

		return rules;
	},

	created() {
		getCaptcha().then(response => {
			this.recaptchaSettings = response;
		});
		if (this.filters) {
			this.setFilters(this.filters);
		}
		this.getDeparmentsJob();
		this.getProjectsJob();
	},
	watch: {
		filters(val) {
			this.setFilters(val);
		}
	},
	methods: {
		removeActiveDepartments(id) {
			this.activeDepartments = this.activeDepartments.filter(
				item => item.id !== id
			);
		},
		removeActiveProjects(id) {
			this.activeProjects = this.activeProjects.filter(
				item => item.id !== id
			);
		},
		removeFilter({ id, type }) {
			switch (type) {
				case DEPARTMENTS_TYPE:
					this.removeDepartmentsItem(id);
					break;
				case PROJECT_TYPE:
					this.removeProjectItem(id);
					break;
			}
		},
		onVerify(value) {
			this.captchaResponse = value;
			this.execSubmit();
		},
		onExpired() {
			this.$refs.recaptcha.reset();
			this.captchaResponse = null;
		},
		onExecute() {
			this.$refs.recaptcha.execute();
		},

		handleSubmit() {
			// this.execSubmit();
			this.$v.$touch();
			if (!this.$v.$invalid && !this.$v.$error) {
				// this.execSubmit();
				this.onExecute();
			} else {
				this.$scrollTo("#form", 500, {});
			}
		},
		onActiveProjectsChange(list) {
			this.activeProjects = list;
			this.onFiltersChange();
		},
		removeProjectItem(id) {
			this.activeProjects = removeItem(this.activeProjects, id);
			this.onFiltersChange();
		},
		onActiveDepartmentsChange(list) {
			this.activeDepartments = list;
			this.onFiltersChange();
		},
		removeDepartmentsItem(id) {
			this.activeDepartments = removeItem(this.activeDepartments, id);
			this.onFiltersChange();
		},
		onFiltersChange() {
			const filters = {
				q: this.search,
				departments: this.activeDepartments.map(item => item.id),
				locations: this.activeLocations.map(item => item.id),
				projects: this.activeProjects.map(item => item.id)
			};

			this.$emit("change", filters);
		},
		setFilters(filters) {
			const { q, locations, departments, projects } = filters;
			if (q !== undefined) {
				this.search = q;
			}

			if (locations) {
				this.activeLocations = locations;
			}

			if (departments) {
				this.activeDepartments = departments;
			}

			if (projects) {
				this.activeProjects = projects;
			}
		},
		resetFilters() {
			if (this.isFiltersEmpty) {
				return;
			}

			const filters = {
				q: "",
				locations: [],
				departments: [],
				projects: []
			};
			this.setFilters(filters);
			this.$emit("change", filters);
		},
		async execSubmit() {
			const body = {
				email: this.email,
				first_name: this.first_name,
				departments: JSON.stringify(
					this.activeDepartments.map(item => item.id)
				),
				uuid: "",
				gdpr_accepted: this.gdpr_accepted,
				projects: JSON.stringify(
					this.activeProjects.map(item => item.id)
				),
				"g-recaptcha-response": this.captchaResponse
			};

			// let formData = new FormData();

			// formData.append("email", this.email);

			// formData.append(
			// 	"departments",
			// 	this.activeDepartments.map(item => item.id)
			// );
			// formData.append(
			// 	"projects",
			// 	this.activeProjects.map(item => item.id)
			// );
			// formData.append("g-recaptcha-response", this.captchaResponse);

			this.$gtm.trackEvent({
				event: "JobSubscribe",
				category: "FormSubmit",
				action: "Submit",
				label: "Jub Subscribe Form",
				value: 1,
				noninteraction: false // Optional
			});

			this.isLoading = true;
			try {
				const result = await postSubscribe(body);
				if (result === undefined) {
					this.apiError =
						"Something went wrong. Please try again later or contact us via email: webdev@bistudio.com";
					this.isLoading = false;
					return;
				}
				this.isLoading = false;
				this.email = null;
				this.departments = [];
				this.projects = [];
				this.first_name = null;

				this.gdpr_accepted = false;

				this.$v.$reset();
				this.$refs.successNotification.open();
				this.apiError = null;
				this.isSent = true;
			} catch (err) {
				if (err.response) {
					const responseData = err.response.data;
					this.apiError = responseData.message;
				} else if (err.request) {
					const errMsg =
						"Server is not available. Please contact us via email: support@bohemia.net";
					this.apiError = errMsg;
					addErrorNotification(errMsg);
				} else {
					const errMsg =
						"Server is not available. Please contact us via email: support@bohemia.net";
					addErrorNotification(errMsg);
				}
				this.$refs.recaptcha.reset();
				this.isLoading = false;
			}
		},
		async getDeparmentsJob() {
			try {
				this.loading = true;
				const { rows, pages, count } = await getDepartments({});
				console.log("rows", rows.rows);
				this.departments.push(...rows.rows);

				this.loading = false;
				this.failed = false;
			} catch (e) {
				console.log("error on departmenst fetching", e);
				this.loading = false;
				this.failed = true;
			}
		},
		async getProjectsJob() {
			try {
				this.loading = true;
				const { rows, pages, count } = await getProjects({});
				rows.rows.map(item => {
					this.projects.push({
						id: item.id,
						name: item.title
					});
				});

				this.loading = false;
				this.failed = false;
			} catch (e) {
				console.log("error on projects fetching", e);
				this.loading = false;
				this.failed = true;
			}
		}
	},
	computed: {
		slug() {
			return this.$route.params.slug;
		},
		...mapState({
			departments: state => state.jobs.departments,
			projects: state => state.jobs.projects
		})
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.badge {
	display: inline-block;
	padding: 5px 10px;
	background-color: rgb(225, 223, 223);
	margin-right: 10px;
	margin-top: 10px;
	border-radius: 10px;
	p {
		color: black;
	}
}

.form-error-wraper {
	margin-top: 20px;
	display: flex;
	justify-content: left;
}
.form-response-error {
	font-weight: 500;
	color: #c32121;
	font-size: 16px;
}
.submit-wrapper {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}

.captcha-wrapper {
	padding-top: 20px;
}

.button-wrapper {
	padding-top: 20px;
	padding-right: 10px;
	flex: 1;
	button {
		border: none;
	}
}

.input-text__form {
	color: #1a1a1a;
}

.mandatory-watermark {
	color: #a5a5a5;
	@media (max-width: $compact) {
		margin-top: 30px;
	}
}

.dividing-line {
	border-bottom: 1px solid #e7e6e6;
	margin-top: 60px;
	margin-bottom: 40px;
}

.form--input {
	margin-bottom: 20px;
	margin-top: 50px;
	label {
		font-family: "Inter UI", sans-serif;
		font-size: 22px;
		line-height: 28px;
		letter-spacing: 0.02px;
		font-weight: 400;
	}
	&__salary {
		display: flex;
	}
}

.radio {
	margin-top: 0;
	margin-bottom: 40px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 28px;
	padding-top: 3px;
	margin-bottom: 12px;
	margin-right: 50px;
	cursor: pointer;
	font-size: 14px;
	font-family: "Inter UI", sans-serif;
	line-height: 16.8px;
	font-weight: 700;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

/* Hide the browser's default checkbox */
.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #fff;
	border-radius: 50%;
	border: 2px solid #1a1a1a;
}

/* On mouse-over, add a grey background color */
.radio-container:hover input ~ .checkmark {
	background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.radio-container input:checked ~ .checkmark {
	background-color: #fff;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.multiple-select {
	width: 100%;
	button {
		border-radius: 0px !important;
	}
}
/* Show the indicator (dot/circle) when checked */
.radio-container input:checked ~ .checkmark:after {
	display: block;
}

/* Style the indicator (dot/circle) */
.radio-container .checkmark:after {
	top: 3px;
	left: 3px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background: #000;
}

.form-group__message {
	color: #c32121;
	font-size: 12px;
}

.application--wrapper__outer {
	background-color: $alabaster;
	position: relative;
}

.application--wrapper__inner {
	max-width: 1000px;
	margin: auto;
}

hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 1px solid gray;
	margin: 1em 0;
	padding: 0;
}

.heading {
	margin: auto;
	margin-bottom: 60px;
	padding-top: 1em;
	font-size: 32px;
	letter-spacing: 0.64px;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.paragraph {
	font-size: 16px;
	margin: auto;

	@media (max-width: $tablet) {
		max-width: 100%;
	}
}

.error {
	border-color: red;
	background: #fdd;
}

.error:focus {
	outline-color: #f99;
}

.valid {
	border-color: #70c165;
}

.valid:focus {
	outline-color: #70c165;
}

.divider--sm {
	padding-bottom: 2em;
}

button[type="submit"] {
	color: #fff;
	padding: 12px 80px;
	border-radius: 30px;
	cursor: pointer;
	font-size: 20px;
}

button[type="submit"]:hover {
}

.form--wrapper {
	width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationPageComponents/SubscribeForm.vue